import { gql } from '@apollo/client/core';

export const CREATE_AVAILABILITY = gql`
  mutation CreateAvailability($start: DateTime!, $end: DateTime!, $kind: AvailabilityKind!) {
    createAvailability(start: $start, end: $end, kind: $kind)
  }
`;

export const CREATE_REPEATING_AVAILABILITY = gql`
  mutation CreateRepeatingAvailability(
    $start: DateTime!
    $end: DateTime!
    $schedule: RepeatingAvailabilitySchedule!
    $effectiveUntil: DateTime
  ) {
    createRepeatingAvailability(start: $start, end: $end, schedule: $schedule, effectiveUntil: $effectiveUntil) {
      id
    }
  }
`;

export const CLEAR_AVAILABILITY = gql`
  mutation ClearAvailability($start: DateTime!, $end: DateTime!) {
    clearAvailability(start: $start, end: $end)
  }
`;

export const REPLACE_AVAILABILITY = gql`
  mutation ReplaceAvailability($clearStart: DateTime!, $clearEnd: DateTime!, $start: DateTime!, $end: DateTime!) {
    replaceAvailability(clearStart: $clearStart, clearEnd: $clearEnd, start: $start, end: $end)
  }
`;

export const EDIT_REPEATING_AVAILABILITY = gql`
  mutation EditRepeatingAvailability(
    $id: UUID!
    $start: DateTime!
    $end: DateTime!
    $schedule: RepeatingAvailabilitySchedule!
    $effectiveUntil: DateTime
  ) {
    editRepeatingAvailability(id: $id, start: $start, end: $end, schedule: $schedule, effectiveUntil: $effectiveUntil) {
      id
    }
  }
`;

export const END_REPEATING_AVAILABILITY = gql`
  mutation EndRepeatingAvailability($id: UUID!, $effectiveUntil: DateTime) {
    endRepeatingAvailability(id: $id, effectiveUntil: $effectiveUntil) {
      id
    }
  }
`;
